import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Songs from "./pages/Songs/Songs.jsx";
import Pinterest from "./pages/Pinterest/Pinterest";
import Password from "./pages/Password/Password";
import { AuthProvider } from "./components/usePasswordAuth";
import ProtectedRoutes from "./components/ProtectedRoutes";

const App = () => {
	return (
		<Router>
			<AuthProvider>
				<Routes>
					<Route path="password" element={<Password />} />
					<Route element={<ProtectedRoutes />}>
						<Route index element={<Home />} />
						<Route path="songs" element={<Songs />} />
						<Route path="pinterest" element={<Pinterest />} />
					</Route>
					<Route path="*" element={<Navigate to="/" />} />
				</Routes>
			</AuthProvider>
		</Router>
	);
};

export default App;
